var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawer-class"},[_c('el-drawer',{attrs:{"title":"Hotel Details","visible":true,"before-close":_vm.close,"direction":"ttb","size":"100%"}},[_c('div',{staticClass:"drawer-container"},[_c('hotel-details')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }